import type { InputHTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  invalid?: boolean
  prefix?: ReactNode
  suffix?: ReactNode
}

export function Input({ className, invalid = false, prefix, suffix, ...props }: InputProps) {
  return (
    <span
      className={cn(
        'flex h-[38px] w-full items-center gap-2 rounded-lg border bg-white px-3 text-sm shadow-[var(--shadow-control)] transition-colors',
        'focus-within:border-[var(--color-primary)] focus-within:ring-2 focus-within:ring-[var(--color-primary-soft)]',
        props.disabled
          ? 'cursor-not-allowed border-[var(--color-panel-border)] bg-[var(--color-surface-muted)] opacity-70 shadow-none'
          : invalid
            ? 'border-[var(--color-danger)]'
            : 'border-[var(--color-control-border)] hover:border-[var(--color-control-border-hover)]',
        className,
      )}
    >
      {prefix ? <span className="shrink-0 text-[var(--color-text-muted)]">{prefix}</span> : null}
      <input
        className="min-w-0 flex-1 bg-transparent text-[var(--color-text)] outline-none placeholder:text-[var(--color-control-placeholder)] disabled:cursor-not-allowed"
        aria-invalid={invalid || undefined}
        {...props}
      />
      {suffix ? <span className="shrink-0 text-[var(--color-text-muted)]">{suffix}</span> : null}
    </span>
  )
}
